import { cn } from "@omni/utils/styles";

import * as ResponsiveImageHelper from "@/components/General/Image/helpers/responsiveImage.helpers";
import { ImageDefault } from "@/components/General/Image/image.default";
import { ImageLink } from "@/components/General/ImageLink/imageLink";
import { useMapped } from "@/context/mapped.context";

import { useBannerSliderContext } from "../../context/bannerSlider.context";

const ImageSlide = () => {
    const { slides } = useBannerSliderContext();
    const { index } = useMapped();

    const slide = slides.at(index);

    if (!slide) {
        return null;
    }

    const imageProps = ResponsiveImageHelper.toImageProps({
        image: slide.responsiveImage,
        mobileImage: slide.responsiveImageMobile
    });

    return (
        <>
            {!slide.href && (
                <ImageDefault
                    {...imageProps}
                    trackingProps={slide.trackingProps}
                    intersectionOptions={{
                        threshold: 0.4
                    }}
                    className={cn(
                        "tw:block tw:mb-4 tw:w-full",
                        imageProps.className
                    )}
                />
            )}
            {slide.href && (
                <ImageLink
                    {...imageProps}
                    href={slide.href}
                    advisorId={undefined}
                    advisorType={undefined}
                    advisorMode={undefined}
                    openInNewTab={slide.openInNewTab}
                    trackingProps={slide.trackingProps}
                    intersectionOptions={{
                        threshold: 0.4
                    }}
                    className={cn("tw:w-full", imageProps.className)}
                />
            )}
        </>
    );
};

export { ImageSlide };
